import { Plus } from '@nackle/icons';
import { getRoms } from 'app/components/routes/roms/actions';
import { selectRom } from 'arcade/sections/cabinets/actions';
import { CabinetContentForm } from 'arcade/sections/cabinets/button-and-panel/CabinetContentForm';
import React, { Component } from 'react';
import { HasPermission } from 'shared/HasPermission';
import { Rom } from 'shared/interfaces';
import SelectGame from 'shared/select-game';
import SlideInPanel from 'shared/slide-in-panel';
import ArcadeCabinetForm from './form';

interface ArcadeCabinetsButtonAndPanelProps {
    readonly slide?: boolean;
    readonly resetCabinetEditor: () => unknown;
    readonly arcadeCabinetId: string | undefined | null;
    readonly hasArcadeCabinetRomId: boolean;
    readonly getRoms: typeof getRoms;
    readonly selectRom: typeof selectRom;
    readonly romOptions: Array<Rom>;
}

interface State {
    /**
     * Keep track of whether there's a translation pane open because Overlays like to hog focus from each other,
     * so we need to be able to turn off some features on the parent overlay while it's open
     */
    childPanelOpen: boolean;
}

export default class ArcadeCabinetsButtonAndPanel extends Component<ArcadeCabinetsButtonAndPanelProps, State> {
    state: State = {
        childPanelOpen: false,
    };

    onPanelClose = () => this.props.resetCabinetEditor();

    render () {
        const {
            arcadeCabinetId,
            hasArcadeCabinetRomId,
            romOptions
        } = this.props;
        const editType = arcadeCabinetId ? 'Update' : 'Add';
        return (
            <HasPermission app="arcade-api" permission="create-cabinet">
                {(hasPermission: boolean) =>
                    <SlideInPanel
                        buttonProps={{
                            icon: <Plus/>,
                            id: 'createArcadeCabinetSlideInPanelButton',
                            alt: 'Create Arcade Cabinet',
                        }}
                        childPanelOpen={this.state.childPanelOpen}
                        disabled={!hasPermission}
                        slide={this.props.slide}
                        onClose={this.onPanelClose}
                        title={`${editType} Arcade Cabinet`}
                        className={'arcade-form'}
                    >
                        {
                            !arcadeCabinetId &&
                            <SelectGame
                                addButtonText="Select"
                                labelText="Select Game ROM"
                                idKey="romId"
                                getOptions={this.props.getRoms}
                                selectGame={this.props.selectRom}
                                gameOptions={romOptions}
                            />
                        }
                        { hasArcadeCabinetRomId && <ArcadeCabinetForm closeAfterSave={this.onPanelClose} /> }
                        { arcadeCabinetId && <>
                            <br />
                            <CabinetContentForm
                                cabinetId={arcadeCabinetId}
                                onChildPanelOpening={this.handleChildPanelOpening}
                                onChildPanelClosed={this.handleChildPanelClosed}
                            />
                        </> }
                    </SlideInPanel>
                }
            </HasPermission>
        );
    }

    handleChildPanelOpening = () => this.setState({ childPanelOpen: true });
    handleChildPanelClosed = () => this.setState({ childPanelOpen: false });
}
